import { useQuery } from "@tanstack/react-query";
import { getEcommAccountingOverview } from "../services/ecommAccountingService";


// ✅ Add "all_time" here
export type PeriodType = "month" | "quarter" | "year" | "all_time";

export const useAccountingEcomm = (periodType: PeriodType) => {
  return useQuery({
    queryKey: ["ecomm-accounting_dashboard", periodType],
    queryFn: () => getEcommAccountingOverview(periodType),
    staleTime: 1000 * 60 * 5,
  });
};